import '../Facets.scss';

import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import {
	AccordionContent,
	AccordionHeader,
	AccordionItem,
	Card,
	CardDivider,
} from '@ao-internal/components-react';

import { parseFacetNameForAttribute } from '../../../utilities/facet-utilities';
import NewEnergyRatingInformation from '../NewEnergyRatingInformation/NewEnergyRatingInformation';
import { FacetValue } from './FacetValue';
import ShowMoreButton from './ShowMoreButton';

export const FacetType = ({
	facet: {
		TotalValuesToShow,
		FacetValues,
		Id,
		Name,
		IsMultiSelect,
		ResetUrl,
	} = {},
	position,
	isLastItem,
}) => {
	const { products } = useSelector((state) => state);
	const whatIsFiveStar = 'What is AO Five Star?';

	const initialFacetsToShow = useRef(
		TotalValuesToShow > 0 ? TotalValuesToShow : 9
	);

	const [facetsToShow, setFacetsToShow] = useState(initialFacetsToShow.current);
	const [hidden, setHidden] = useState(false);

	let shouldRender = true;

	if (Id === 'onlyshowinstock') {
		shouldRender = products.some(({ State }) => State === 'LiveProduct');
	}

	if (!shouldRender) {
		return null;
	}

	return (
		<Card
			square
			noPadding
			noBorder
			data-facet-name={parseFacetNameForAttribute(Name)}>
			<AccordionItem isOpen={!hidden} groupName={Name}>
				<AccordionHeader
					as="h3"
					onClick={() => setHidden(!hidden)}
					data-testid="facet-hide-button"
					className="m-0 ">
					<span className="text-title text-secondary">{Name}</span>
				</AccordionHeader>
				<AccordionContent noPadding>
					{Id?.includes('energyrating') && <NewEnergyRatingInformation />}

					<FacetValue
						{...{
							Name,
							IsMultiSelect,
							FacetValues,
							ResetUrl,
							position,
							facetsToShow,
							isColourSwatch: Id === 'colour',
						}}
					/>

					<ShowMoreButton
						{...{
							FacetValues,
							initialFacetsToShow,
							showAllFacets: () => setFacetsToShow(FacetValues.length),
							resetFacets: () => setFacetsToShow(initialFacetsToShow.current),
						}}
					/>
				</AccordionContent>
			</AccordionItem>
			{!hidden && Id?.includes('aol_hasmemberprice') && (
				<a
					href="/help-and-advice/finance-and-savings/ao-five-star"
					target="_blank"
					className="block text-body-sm text-link pt-4 pb-2 px-4 md:text-xs">
					{whatIsFiveStar}
				</a>
			)}
			{!isLastItem && <CardDivider noPadding noMargin />}
		</Card>
	);
};

export default FacetType;
